export class Store {
}